<template>
    <div class="setting">
        <div v-if="embed_mode" class="embed-setting-bar">
            <a-button type="text" @click="goBackFromSetting">
                <LeftOutlined />
                {{ $t('common.back') }}
            </a-button>
            <span class="embed-setting-title">{{ $t('setting.setting') }}</span>
        </div>
        <a-row>
            <a-col :span="8" class="setting_left_zone">
                <a-card :title="$t('setting.setting')" style="width: auto; height: 95vh;">
                    <a-list size="large" :bordered="false" :data-source="data">
                        <template #renderItem="{ item }">
                            <a-list-item
                                @click="chooseType(item.type)"
                                class="setting-menu-item"
                                :class="{ active: current_type == item.type }"
                                style="cursor: pointer;"
                            >
                                <div style="display: inline-block; width: 50%; font-size: 16px;">
                                    <AppstoreAddOutlined v-if="item.type == 'general'" />
                                    <InfoCircleOutlined v-if="item.type == 'about'" />
                                    <UserOutlined v-if="item.type == 'account'" />
                                    <span style="margin-left: 15px;">{{ $t('setting.' + item.name) }}</span>
                                </div>
                                <div style="display: inline-block; width: 50%; text-align: right;">
                                    <RightOutlined />
                                </div>
                            </a-list-item>
                        </template>
                    </a-list>
                </a-card>
            </a-col>
            <a-col :span="24" v-if="is_mobile" class="setting-mobile-tabs">
                <a-tabs v-model:activeKey="current_type" centered size="large">
                    <a-tab-pane key="account" :tab="$t('setting.account')"></a-tab-pane>
                    <a-tab-pane key="general" :tab="$t('setting.general')"></a-tab-pane>
                    <a-tab-pane key="about" :tab="$t('setting.about')"></a-tab-pane>
                </a-tabs>
            </a-col>
            <a-col :lg="{span: 16}" :xs="{span: 24}" class="setting_right_zone">
                <a-card title_bak="$t('setting.' + current_type)" style="width: auto; height: 95vh;">
                    <div v-if="current_type == 'account'">
                        <a-card title="" :bordered="false" class="setting-block" style="width: 100%; font-size: 16px;">
                            <div>
                                <div style="display: inline-block; width: 50%; font-size: 16px;">
                                    <span style="margin-left: 15px;">{{ $t('setting.logo_label') }}</span>
                                </div>
                                <div style="display: inline-block; width: 50%; text-align: right;">
                                    <img :src="slogo" style="width: 60px; height: auto;"/>
                                </div>
                            </div>
                            <a-divider />
                            <div>
                                <div style="display: inline-block; width: 50%; font-size: 16px;">
                                    <span style="margin-left: 15px;">{{ $t('setting.account') }}</span>
                                </div>
                                <div style="display: inline-block; width: 50%; text-align: right;">
                                    <span>{{ user_name }}</span>
                                </div>
                            </div>
                            <a-divider />
                            <div>
                                <div style="display: inline-block; width: 50%; font-size: 16px;">
                                    <span style="margin-left: 15px;">{{ $t('setting.name_label') }}</span>
                                </div>
                                <div style="display: inline-block; width: 50%; text-align: right;">
                                    <span>{{ sname }}</span>
                                </div>
                            </div>
                        </a-card>
                        <a-button @click="doLogout" style="margin-top: 40px; width: 100%; height: 50px; color: red;">{{ $t('setting.logout_btn') }}</a-button>
                    </div>
                    
                    <div v-if="current_type == 'general'">
                        <a-card title="" :bordered="false" class="setting-block" style="margin-top: 20px; width: 100%; font-size: 16px;">
                            <div @click="chooseLanuage">
                                <div style="display: inline-block; width: 50%; font-size: 16px;">
                                    <span style="margin-left: 15px;">{{ $t('setting.custom_language_label') }}</span>
                                </div>
                                <div style="display: inline-block; width: 50%; text-align: right;">
                                    <span>{{ language_text }}</span>
                                    <RightOutlined />
                                </div>
                            </div>
                            <a-divider />
                            <div class="dark-mode-row">
                                <div style="display: inline-block; width: 50%; font-size: 16px;">
                                    <span style="margin-left: 15px;">{{ $t('setting.dark_mode_label') }}</span>
                                </div>
                                <div style="display: inline-block; width: 50%; text-align: right;">
                                    <a-switch
                                        :checked="theme_mode === 'dark'"
                                        :checked-children="$t('setting.dark_mode_on')"
                                        :un-checked-children="$t('setting.dark_mode_off')"
                                        @change="onDarkModeChange"
                                    />
                                </div>
                            </div>
                        </a-card>
                    </div>
                    <div v-if="current_type == 'about'">
                        <a-card title="" :bordered="false" class="setting-block" style="margin-top: 20px; width: 100%; font-size: 16px;">
                            <div>
                                <div style="display: inline-block; width: 50%; font-size: 16px;">
                                    <span style="margin-left: 15px;">{{ $t('setting.version_label') }}</span>
                                </div>
                                <div style="display: inline-block; width: 50%; text-align: right;">
                                    <span>{{ version + ' (' + build_number + ')' }}</span>
                                </div>
                            </div>
                            <a-divider />
                            <div @click="openPage('privacy')">
                                <div style="display: inline-block; width: 50%; font-size: 16px;">
                                    <span style="margin-left: 15px;">{{ $t('setting.privacy_label') }}</span>
                                </div>
                                <div style="display: inline-block; width: 50%; text-align: right;">
                                    <RightOutlined />
                                </div>
                            </div>
                            <a-divider />
                            <div @click="openPage('terms')">
                                <div style="display: inline-block; width: 50%; font-size: 16px;">
                                    <span style="margin-left: 15px;">{{ $t('setting.terms_label') }}</span>
                                </div>
                                <div style="display: inline-block; width: 50%; text-align: right;">
                                    <RightOutlined />
                                </div>
                            </div>
                        </a-card>
                    </div>
                </a-card>
            </a-col>
        </a-row>
        <a-modal v-model:open="show_language_layer" :footer="null" title="Select Language">
            <a-radio-group v-model:value="language">
                <a-radio value="eng">English</a-radio>
                <a-radio value="chn">中文简体</a-radio>
                <a-radio value="cht">中文繁體</a-radio>
            </a-radio-group>
        </a-modal>
    </div>
</template>

<script>
    import {
        RightOutlined,
        AppstoreAddOutlined,
        InfoCircleOutlined,
        UserOutlined,
        LeftOutlined,
    } from '@ant-design/icons-vue';

    import { Modal } from 'ant-design-vue';
    import { mapMutations, mapState } from 'vuex';

    export default {
        name: 'SettingPage',
        components: {
            RightOutlined,
            AppstoreAddOutlined,
            InfoCircleOutlined,
            UserOutlined,
            LeftOutlined,
        },
        data() {
            return {
                data: [
                    { name: 'account', type: 'account' },
                    { name: 'general', type: 'general' },
                    { name: 'about', type: 'about' },
                ],
                current_type: 'account',
                sname: this.$store.state.app.sname,
                slogo: this.$store.state.app.slogo,
                sid: this.$store.state.app.sid,
                user_name: this.$store.state.app.user_name,
                show_language_layer: false,
                language: this.$i18n.locale ,
                version: this.$store.state.app.version,
                build_number: this.$store.state.app.build_number,
                is_mobile: this.$store.state.app.is_mobile,
            }
        },
        created() {
        },
        computed: {
            ...mapState({
                embed_mode: (state) => state.app.embed_mode,
                theme_mode: (state) => state.app.theme_mode
            }),
            language_text() {
                if (this.language == 'eng') {
                    return 'English';
                } else if (this.language == 'chn') {
                    return '中文简体';
                } else if (this.language == 'cht') {
                    return '中文繁體';
                } else if (this.language == 'test') {
                    return 'Test';
                }

                return 'Other';
            }
        },
        watch: {
            language() {
                window.localStorage.setItem('merchant_language', this.language);

                if (this.language == 'eng') {
                    this.$i18n.locale = 'eng';
                } else if (this.language == 'chn') {
                    this.$i18n.locale = 'chn';
                } else if (this.language == 'cht') {
                    this.$i18n.locale = 'cht';
                }
            }
        },
        methods: {
            ...mapMutations({
                APP_SET_THEME_MODE: 'app/APP_SET_THEME_MODE'
            }),
            onDarkModeChange(checked) {
                this.APP_SET_THEME_MODE(checked ? 'dark' : 'light');
            },
            goBackFromSetting() {
                if (window.history.length > 1) {
                    this.$router.back();
                    return;
                }
                this.$router.replace({ path: '/waitlist' });
            },
            chooseType(type) {
                this.current_type = type;
            },
            doLogout() {
                let that = this;
                Modal.confirm({
                    title: this.$t('setting.logout_tip'),
                    okText: this.$t('common.confirm'),
                    cancelText: this.$t('common.cancel'),
                    maskClosable: true,
                    onOk() {
                        window.localStorage.removeItem('token');
                        window.localStorage.removeItem('user_name');
                        window.localStorage.removeItem('role');
                        window.localStorage.removeItem('sid');
                        window.localStorage.removeItem('slogo');
                        window.localStorage.removeItem('sname');
                        window.localStorage.removeItem('timezone');

                        that.$router.replace({
                            path: '/login'
                        });
                    },
                    onCancel() {
                    },
                });
            },
            openPage(type) {
                if (type == 'privacy') {
                    window.open('https://www.minitable.net/privacypolicy.html');
                } else if (type == 'terms') {
                    window.open('https://www.minitable.net/termofuse.html');
                }
            },
            chooseLanuage() {
                this.show_language_layer = true;
            }
        }
    }
</script>

<style scoped>
    .setting {
        height: 100%;
        background: var(--app-bg);
        color: var(--app-text);
    }
    .setting-mobile-tabs {
        background-color: var(--app-surface);
    }
    .setting-block {
        background-color: var(--app-surface-muted) !important;
    }
    .setting-menu-item.active {
        background-color: var(--app-surface-muted);
    }
    .dark-mode-row {
        display: flex;
        align-items: center;
    }
    .embed-setting-bar {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 8px;
        flex-shrink: 0;
    }
    .embed-setting-title {
        font-size: 16px;
        font-weight: 600;
    }
    @media screen and (max-width: 768px) {
        .setting {
            width: 100%;
            max-width: 100%;
            overflow-x: hidden;
            height: 100%;
        }
        .setting_left_zone {
            display: none;
        }
    }
</style>
